var map = {
	"./bubble-fs.png": "399b",
	"./bubble-in.png": "c76f",
	"./bubble.png": "2267",
	"./carousel-disabled.png": "4c0d",
	"./carousel-fs.png": "23fa",
	"./carousel-in.png": "20f7",
	"./carousel.png": "baac",
	"./embed-tag.svg": "9546",
	"./embed.png": "7b06",
	"./embedded-in.png": "acfd",
	"./example-customer.png": "ae77",
	"./hovered-play-icon.png": "3239",
	"./no-code-tag.svg": "b12d",
	"./play-icon-grey.png": "79c4",
	"./play-icon.png": "b7bb",
	"./popup-in.png": "2a57",
	"./popup.png": "d817",
	"./select-card.png": "93ce",
	"./selected-embed-tag.svg": "5fba",
	"./selected-no-code-tag.svg": "b57a",
	"./selected-play-icon.png": "110f",
	"./shoppable-flow.png": "7548",
	"./sticky-in.png": "7837",
	"./sticky-play-button-disabled.png": "9efd",
	"./sticky-play-button.png": "08b8",
	"./stories-2.png": "a9d3",
	"./stories-fs.png": "5592",
	"./stories.png": "a278",
	"./tooltip-icon.png": "7f11",
	"./tooltip-icon.svg": "7a9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe23";